import {InjectionToken} from '@angular/core'

export const SESSION_STORAGE_QUERY_PARAMS_KEY = 'bgo.queryParams'
export const VOUCHER_QUERY_PARAM = 'voucher'

type QueryParamOptions = {
  clearWhenStoring: boolean
}
export type QueryParams = Record<string, QueryParamOptions>

export const queryParamOptions: QueryParams = {
  [VOUCHER_QUERY_PARAM]: {clearWhenStoring: true},
}

export const QUERY_PARAMS_TOKEN = new InjectionToken<QueryParams>('Query Params Injection Token', {
  providedIn: 'root',
  factory: () => queryParamOptions,
})
